import styled, { css } from 'styled-components';

const FILTER_TAB_COLORS = css`
    background: ${(props) => props.theme.shades.white['10']};
    color: ${(props) => props.theme.shades.white['50']};
`;

export const RangeOptions = styled.ul<{ isWide?: boolean }>`
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row !important;
    width: 170px;
    column-gap: 10px;

    ${({ isWide }) =>
        isWide &&
        css`
            width: 100%;
        `}

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
    }
`;

export const ListNumberInput = styled.li<{ isWide?: boolean }>`
    max-width: 80px;
    display: inline;

    > input {
        width: 80px;
        height: 40px;
        display: inline;
        ${FILTER_TAB_COLORS}

        border-radius: 5px;
        border: none;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 120%;
        letter-spacing: -0.03em;

        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        -moz-appearance: textfield;

        &::placeholder {
            color: ${(props) => props.theme.shades.white['50']};
        }
    }

    ${({ isWide }) =>
        isWide &&
        css`
            width: 100%;
            max-width: initial;
            > input {
                width: 100%;
            }
        `}

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        max-width: initial;
        width: 100%;
        > input {
            width: 100% !important;
        }
    }
`;
